import { all, call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'

const Api = {
  fetchData () {
    return axios.get('https://hpe-ms-alliance-demo-data.mreach.com/api/v1/data')
  }
}

function normalize (data) {
  const normalized = {}

  data.forEach((item) => {
    normalized[item.id] = item
  })

  return normalized
}

function normalizeSettings (settings) {
  const normalized = {}

  settings.forEach((setting) => {
    normalized[setting.name] = setting.value
  })

  return normalized
}

function * fetchData () {
  try {
    const data = yield call(Api.fetchData)
    const payload = data.data

    if (data.statusText === 'OK') {
      yield all([
        put({ type: 'CONTENT_DISPLAYS_ADD', data: normalize(payload.contentDisplays) }),
        put({ type: 'INTERACTIVE_ELEMENTS_ADD', data: normalize(payload.interactiveElements) }),
        put({ type: 'MENUS_ADD', data: normalize(payload.menus) }),
        put({ type: 'MODALS_ADD', data: normalize(payload.modals) }),
        put({ type: 'PAGES_ADD', data: normalize(payload.pages) }),
        put({ type: 'SETTINGS_ADD', data: normalizeSettings(payload.settings) }),
        put({ type: 'SLIDES_ADD', data: normalize(payload.slides) }),
        put({ type: 'SLIDESHOWS_ADD', data: normalize(payload.slideshows) })
      ])

      yield put({ type: 'APP_DATA_LOADED' })
    }
  } catch (e) {
    // failure handle
  }
}

function * dataSaga () {
  yield takeLatest('FETCH_DATA', fetchData)
}

export default dataSaga



// WEBPACK FOOTER //
// ./src/sagas.js